import { useMutation, useQueryClient } from '@tanstack/react-query';
import { convertHouseUpdateValues } from 'gcs-common/helper/houseAdministrationHelper';
import { useApiClient } from '../../client';
import { CurrentUserQueryKeys } from '../current-user/current-user-api';
import type { Parameters, RequestBody } from './../../../../../types/typeHelper';

export function useUpdateHouseMutation() {
  const queryClient = useQueryClient();
  const client = useApiClient();
  return useMutation({
    mutationFn: async ({
      body,
      path,
    }: {
      body: RequestBody<'/admin/houses/{house_id}', 'put'>;
      path: Parameters<'/admin/houses/{house_id}', 'put'>['path'];
    }) => {
      return client.PUT('/admin/houses/{house_id}', {
        params: {
          path,
        },
        body: convertHouseUpdateValues(body),
      });
    },
    onSettled: async () => {
      queryClient.invalidateQueries({ queryKey: [CurrentUserQueryKeys.GET_CURRENT_USER] });
    },
  });
}
